import axios from 'axios';

import Config from '@/config/variables';

export default () => {
  axios.defaults.baseURL = Config.BaseUrl;
  axios.defaults.timeout = Config.RequestTimeout;
  axios.defaults.headers.post['Content-Type'] = 'application/json';
  // eslint-disable-next-line dot-notation
  axios.defaults.headers.common['Device-Type'] = 'WEB';
};
